<script>
import ChartDataLabels from 'chartjs-plugin-datalabels'
import Pie from '../components/widgets/pie.vue'
import {emptyCenterTextPlugin, paddingBelowLegends} from "@/utils/chartjs/graphPlugins";
import {round} from "lodash";


export default {
  name: "harvest-regional-performance",
  components: {
    Pie,
  },
  props: {
    data: {
      type: Array, default() {
        return []
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    dataGroupByZoneId() {
      return Object.groupBy(this.data, ({zone_id}) => zone_id)
    },
    totalQuantity() {
      return this.data.reduce((carry, {quantity}) => round(carry + quantity, 2), 0)
    },
    totalRevenue() {
      return this.data.reduce((carry, {revenue}) => round(carry + revenue, 2), 0)
    },
    zoneIds() {
      return Object.keys(this.dataGroupByZoneId)
    },
    chartLabels() {
      return this.zoneIds.map(zoneId => `${this.lodash.upperFirst(this.$t('zones.singular'))} ${zoneId}`)
    },
    quantityChartData() {
      let data = this.zoneIds
          .map(zoneId => this.dataGroupByZoneId[zoneId]
              .reduce((carry, {quantity}) => round(carry + quantity, 2), 0)
          )
      let colors = this.zoneIds.map(this.pieColorByZoneId)
      return {
        datasets: [{
          data: data,
          backgroundColor: colors,
          borderColor: colors,
        }],
        labels: this.chartLabels,
      }
    },
    revenueChartData() {
      let data = this.zoneIds
          .map(zoneId => this.dataGroupByZoneId[zoneId]
              .reduce((carry, {revenue}) => round(carry + revenue, 2), 0)
          )
      let colors = this.zoneIds.map(this.pieColorByZoneId)
      return {
        datasets: [{
          data: data,
          backgroundColor: colors,
          borderColor: colors,
        }],
        labels: this.chartLabels,
      }
    },
    quantityChartOptions() {
      let vm = this
      return {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: false
        },
        legend: {
          onClick: (e) => e.stopPropagation(),
        },
        plugins: {
          datalabels: {
            textAlign: 'start',
            align: 'end',
            clamp: true,
            anchor: 'end',
            borderRadius: 5,
            offset: 5,
            padding: 4,
            borderColor: '#FFF',
            color: '#161B4D',
            font: {
              size: 12,
              weight: 'bold'
            },
            formatter: function (value, context) {
              let label = context.chart.data.labels[context.dataIndex];
              let percentage = vm.$numeral(round(value / vm.totalQuantity * 100, 2)).format('0,0.[00]') + "%";
              let formattedValue = vm.$numeral(round(value / 1000, 2)).format('0,0.[00]')
              return `${label}\n${percentage}\n${formattedValue} ton`;
            }
          },
        },
        layout: {
          padding: {
            right: 25,
            bottom: 55,
            left: 25
          }
        }
      }
    },
    revenueChartOptions() {
      let vm = this
      return {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: false
        },
        legend: {
          onClick: (e) => e.stopPropagation(),
        },
        plugins: {
          datalabels: {
            textAlign: 'start',
            align: 'end',
            clamp: true,
            anchor: 'end',
            borderRadius: 5,
            offset: 5,
            padding: 4,
            borderColor: '#FFF',
            color: '#161B4D',
            font: {
              size: 12,
              weight: 'bold'
            },
            formatter: function (value, context) {
              let label = context.chart.data.labels[context.dataIndex];
              let percentage = vm.$numeral(round(value / vm.totalRevenue * 100, 2)).format('0,0.[00]') + "%";
              let formattedValue = vm.$numeral(value).format('$ 0,0.00')
              return `${label}\n${percentage}\n${formattedValue}`;
            }
          }
        },
        layout: {
          padding: {
            right: 25,
            bottom: 55,
            left: 25
          }
        }
      }
    },
    chartPlugins() {
      return [
        ChartDataLabels,
        emptyCenterTextPlugin,
        paddingBelowLegends,
      ]
    },
    cardHeaderText() {
      return this.lodash.startCase(this.$t('performance_dashboards.harvest_regional_performance'))
    }
  },
  methods: {
    pieColorByZoneId(zoneId) {
      if (zoneId == 1) {
        return '#1B77DF'
      } else if (zoneId == 2) {
        return '#FF9D0B'
      } else if (zoneId == 3) {
        return '#BEBEBE'
      } else {
        return '#FF0000'
      }
    }
  }
}
</script>

<template>
  <div class="col-12">
    <b-card class="shadow-sm mb-4" no-body>
      <b-card-body>
        <h3 class="dashboard-card-header mb-4">{{ cardHeaderText }}</h3>
        <b-row>
          <b-col class="mb-3 mb-md-0" cols="6" lg="6" md="12">
            <b-card>
              <h3 class="dashboard-card-header mb-2">Tonase</h3>
              <pie
                  :data="quantityChartData"
                  :height="350"
                  :options="quantityChartOptions"
                  :plugins="chartPlugins"
              ></pie>
            </b-card>
          </b-col>

          <b-col class="mb-3 mb-md-0" cols="6" lg="6" md="12">
            <b-card>
              <h3 class="dashboard-card-header mb-2">Revenue</h3>
              <pie
                  :data="revenueChartData"
                  :height="350"
                  :options="revenueChartOptions"
                  :plugins="chartPlugins"
              ></pie>
            </b-card>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<style lang="scss" scoped>
.overview-card-title {
  color: #667085;
  font: 500 16px/24px Inter;
}

.overview-card-body {
  color: #1664D8;
  font: 800 20px/28px Inter;
}
</style>